import React, { useRef, useEffect, useState } from 'react'

import { normalizeQrCountry, QR_COUNTRIES } from 'helpers/qrCountry'

export default function ExplanatoryVideo({ country }) {
  const videoRef = useRef(null)
  const [isMuted, setIsMuted] = useState(true)

  const toggleMute = () => {
    const video = videoRef.current
    if (video) {
      const newMuted = !video.muted
      video.muted = newMuted
      video.volume = newMuted ? 0 : 1
      video.play()
      setIsMuted(newMuted)
    }
  }

  return (
    <div className='w-[85vw] h-[60vh] flex items-center justify-center bg-black'>
      <video
        ref={videoRef}
        src={normalizeQrCountry(country) === QR_COUNTRIES.CHILE
          ? '/video_waiting_room_cl.mp4'
          : '/video_waiting_room.mp4'}
        className='w-full h-full object-contain'
        autoPlay
        muted
        loop
        playsInline
      />
      <button
        type='button'
        onClick={toggleMute}
        className='absolute top-4 right-4 bg-indigo-500 text-white px-3 py-2 rounded shadow'
      >
        {isMuted ? 'Activar sonido 🔊' : 'Desactivar sonido 🔇'}
      </button>
    </div>
  )
}
